import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Autocomplete,
  Chip
} from "@mui/material";
import { getRoleData ,getAllowedRoleData} from "../../../store/actions/rolePermissionActions";
import { getAllLocationlist } from "../../../store/actions/locationActions";

export default function AddUserForm({ open, handleClose, handleSubmit, form, setForm, editUser }) {
  const dispatch = useDispatch();

  const locationList = useSelector(({ loadsReducer }) => loadsReducer.locationList);
  // const roleList = useSelector(({ userReducer }) => userReducer.roleList); 

  // const stringAllLocationList = locationList?.map(item => ({
  //   label: String(item.locationNumber),
  //   value: item.locationNumber
  // })) || [];

  const [rolesFetched, setRolesFetched] = useState(false);
  const [roleList, setRoleList] = useState([])
  const [stringAllLocationList, setStringAllLocationList] = useState([]);


  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
  );

  // Fetch roles if not already fetched
  useEffect(() => {
    const userId = localStorage.getItem('userId') ;
    const  roleId= permissionsData?.roleId ;
    // if (!rolesFetched) {
    //   dispatch(getAllowedRoleData(roleId,userId)).then((res) => {
    //      setRolesFetched(true); setRoleList(res) });
    // }
    if (!rolesFetched) {
      dispatch(getRoleData()).then((res) => {
         setRolesFetched(true); setRoleList(res) });
    }
  }, [dispatch, rolesFetched]);

  useEffect(() => {
    if (permissionsData?.roleId === 1 || permissionsData?.roleId === 2) {
       // Admin → get full location list from API
      dispatch(getAllLocationlist()).then((res) => {
        const formatted = (res || []).map((loc) => ({
          label: String(loc),
          value: loc
        }));
        setStringAllLocationList(formatted);
      });
    } else {
      // Non-admin → use locationList from Redux store
      const formatted = (locationList || []).map((item) => ({
        label: String(item.locationNumber),
        value: item.locationNumber
      }));
      setStringAllLocationList(formatted);
    }
  }, [permissionsData]);

  // Pre-fill form in edit mode
  useEffect(() => {
    if (editUser) {
      setForm({
        id: editUser.id || "",
        name: editUser.name || "",
        email: editUser.email || "",
        roleId: editUser.roleId || "",
        roleName: editUser.roleName || "",
        allowedLocations: editUser.allowedLocations?.map(String) || [],
        defaultLocation: String(editUser.defaultLocation) || ""
      });
    }
  }, [editUser, setForm]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleAllowedLocationsChange = (event, value) => {
    setForm(prev => ({
      ...prev,
      allowedLocations: value
    }));
  };

  const handleDefaultLocationChange = (event, value) => {
    setForm(prev => ({
      ...prev,
      defaultLocation: value || ""
    }));
  };

  const handleRoleChange = (e) => {
    const selectedRoleId = e.target.value;
    const selectedRole = roleList.find(role => role.id === selectedRoleId);
    setForm(prev => ({
      ...prev,
      roleId: selectedRoleId,
      roleName: selectedRole?.name || ""
    }));
  };

  const onSubmit = () => {
    const payload = {
      name: form.name,
      email: form.email,
      roleId: form.roleId,
      locationIds: form.allowedLocations.map(Number),
      defaultLocation: Number(form.defaultLocation)
    };
    handleSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editUser ? "Edit User" : "Add User"}</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>Role</InputLabel>
            <Select
              name="roleId"
              value={form.roleId}
              onChange={handleRoleChange}
              label="Role"
            >
              {(roleList || []).map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <InputLabel
            htmlFor="allowedLocations"
            style={{ color: "black", marginTop: "10px", fontSize: "0.85rem" }}
          >
            Allowed Locations
          </InputLabel>
          <Autocomplete
            multiple
            filterSelectedOptions
            size="small"
            id="allowedLocations"
            options={stringAllLocationList.map(loc => loc.label)}
            getOptionLabel={(option) => option}
            value={form.allowedLocations || []}
            onChange={handleAllowedLocationsChange}
            renderInput={(params) => (
              <TextField {...params} name="allowedLocations" />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip label={option} {...getTagProps({ index })} />
              ))
            }
            clearIcon={null}
            sx={{ width: '100%' }}
          />

          <InputLabel
            htmlFor="defaultLocation"
            style={{ color: "black", marginTop: "10px", fontSize: "0.85rem" }}
          >
            Default Location
          </InputLabel>
          <Autocomplete
            filterSelectedOptions
            size="small"
            id="defaultLocation"
            // options={stringAllLocationList.map(loc => loc.label)}
            options={form?.allowedLocations?.map(loc => loc)}
            allowedLocations
            getOptionLabel={(option) => option}
            value={form.defaultLocation || ""}
            onChange={handleDefaultLocationChange}
            renderInput={(params) => (
              <TextField {...params} name="defaultLocation" />
            )}
            clearIcon={null}
            sx={{ width: '100%' }}
          />

          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            <Button onClick={handleClose} variant="outlined" color="secondary">
              Cancel
            </Button>
            <Button onClick={onSubmit} variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

